// hooks/useAtualizarDados.ts
import { useState } from "react";
import { cadastrarInfoPagService } from "../../../services/cadastrarInfoPagService";

export const useCadastrar = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const cadastrar = async (values: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const infoPag = await cadastrarInfoPagService(values);
      if (infoPag) {
        setSuccess("Chave pix cadastrada com sucesso!");
      } else {
        setError("Não foi possível cadastrar chave pix. Tente Novamente!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { cadastrar, isLoading, isSuccess, error, success };
};
